import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { comparerByDate } from '@app/comparers';
import {
  CommentActionsUnion,
  CommentActionTypes
} from '@core/actions/comment.actions';
import { Comment } from '@app/models/comment';

export interface State extends EntityState<Comment> {
  loading: boolean;
  loaded: boolean;
}

export const adapter: EntityAdapter<Comment> = createEntityAdapter<Comment>({
  selectId: (comment: Comment) => comment.id,
  sortComparer: comparerByDate('ASC', 'createdAt')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: CommentActionsUnion
) {
  switch (action.type) {
    // case CommentActionTypes.Load:
    //   return { ...state, loading: true };

    // case CommentActionTypes.LoadFail:
    //   return { ...state, loading: false };

    // case CommentActionTypes.LoadSuccess:
    //   return adapter.addAll(action.comments, {
    //     ...state,
    //     loading: false,
    //     loaded: true
    //   });

    case CommentActionTypes.LoadByProduct:
      return { ...state, loading: true };

    case CommentActionTypes.LoadByProductFail:
      return { ...state, loading: false };

    case CommentActionTypes.LoadByProductSuccess:
      return { ...state, loading: false, loaded: true };

    case CommentActionTypes.AddOne:
      return adapter.addOne(action.comment, state);

    case CommentActionTypes.AddMany:
      return adapter.addMany(action.comments, state);

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
